export const AB_TEST = {
  documentList: 'document_list',
  trialWordLimit: 'trial_word_limit_2_5k_5k',
  mobileLandingPage: 'mobile_landing_page',
  socialAdvancedOptions: 'social_advanced_options',
  personalizedOnboarding: 'personalized_onboarding',
};

export const AB_TEST_GROUP = {
  control: 'control',
  experiment: 'experiment',
};

export const getABTestValue = (entity, testName, defaultValue = null) => {
  const abTests = entity?.abTests;
  const test = abTests?.find(({ name }) => name === testName);
  return test?.value || defaultValue;
};

export const getTrialWordTestValue = (customer) => {
  return getABTestValue(customer, AB_TEST.trialWordLimit, AB_TEST_GROUP.control);
};

export const isTrialWordExperiment = (customer) => {
  const testValue = getTrialWordTestValue(customer);

  return testValue === AB_TEST_GROUP.experiment;
};
